import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './app/auth.service';
import { environment } from './environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient, private auth: AuthService) { }

  /**
 * Get Contractor List
 * @returns
 */
  getContractorList() {
    return this.http.get(`${this.baseURL}/rhAPI/contractors`);
  }

  /**
* Get designers List
* @returns
*/
  getDesignersList(contractor_id) {
    return this.http.get(`${this.baseURL}/rhAPI/designers/${contractor_id}`);
  }


}
